export type Tome = {
  id: string;
  label: string;
  title: string;
  subtitle: string;
  text: string;
  items: string[];
  closing: string;
  cover: string;
  coverAlt: string;
};

export type Bonus = {
  number: string;
  title: string;
  description: string;
  pages: string;
  cover: string;
};

export const heroIndicators = [
  '📱 Formato PDF',
  '🖨️ Listo para imprimir',
  '🇦🇷 Pensado para familias de Argentina',
  '🛡️ Garantía de 7 días',
  '💳 Mercado Pago',
  '⚡ Entrega inmediata',
];

export const purchaseAssurances = ['🛡️ Garantía de 7 días', '💳 Pagá con Mercado Pago', '⚡ Entrega inmediata'];

export const videoPoints = [
  'Ideas organizadas por proyecto',
  'Materiales y pasos para acompañar el armado',
  'Alternativas tenebrosas y divertidas',
];

export const kitHighlights = ['16 propuestas de disfraces', '7 archivos PDF', 'Materiales fáciles de conseguir'];

export const tomes: Tome[] = [
  {
    id: 'tomo-1',
    label: 'TOMO 1 · 40 PÁGINAS',
    title: 'Disfraces Tenebrosos',
    subtitle: 'Para quienes disfrutan el lado más misterioso de Halloween.',
    text: 'Elegí entre ocho personajes y compartí el armado con tus hijos, acompañando cada tarea según su edad.',
    items: ['Fantasma', 'Vampiro', 'Bruja', 'Esqueleto', 'Zombi', 'Murciélago', 'Espantapájaros', 'Monstruo de sombras'],
    closing: 'Propuestas para transformar materiales cotidianos en personajes de Halloween.',
    cover: 'https://cdn.magicpatterns.com/uploads/dWjgvvzQmBwmVU2LhsfeFd/Disfraces_tenebrosos_en_familia-1.png',
    coverAlt: 'Portada del Tomo 1: Disfraces Tenebrosos',
  },
  {
    id: 'tomo-2',
    label: 'TOMO 2 · 40 PÁGINAS',
    title: 'Disfraces Divertidos',
    subtitle: 'Toda la magia de disfrazarse, con personajes simpáticos y coloridos.',
    text: 'Para los chicos que prefieren jugar con la imaginación sin elegir un personaje de terror.',
    items: ['Calabaza', 'Monstruo de colores', 'Fantasmita', 'Gato', 'Robot', 'Dragón', 'Búho', 'Mago'],
    closing: 'Elijan el personaje que más les guste y háganlo propio con sus colores y detalles.',
    cover: 'https://cdn.magicpatterns.com/uploads/qEG8LbNiqzGmwHhjkvYpo7/Calabaza,_robot_y_dragon__disfraces_divertidos-2.png',
    coverAlt: 'Portada del Tomo 2: Disfraces Divertidos',
  },
];

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Bolsitas monstruosas para golosinas',
    description: 'Ideas para preparar bolsitas temáticas y sumar un detalle hecho en casa.',
    pages: '12 páginas',
    cover: 'https://cdn.magicpatterns.com/uploads/eT5iQXr66GGMRfNLjVkmAy/Bolsitas_monstruosas_de_Halloween-3.png',
  },
  {
    number: '02',
    title: 'Transformá tu casa para Halloween',
    description: 'Propuestas de decoración para darle ambiente a la celebración.',
    pages: '12 páginas',
    cover: 'https://cdn.magicpatterns.com/uploads/4YHhz1pqaWadJMKApRXJdq/Decoracion_familiar_de_Halloween_con_papel-4.png',
  },
  {
    number: '03',
    title: 'Juegos para una noche monstruosa',
    description: 'Actividades para compartir risas y momentos de juego en familia.',
    pages: '12 páginas',
    cover: 'https://cdn.magicpatterns.com/uploads/jso9MjmCemNbJJS895AWkH/Juegos_de_calabazas_en_familia-6.png',
  },
  {
    number: '04',
    title: 'Maquillajes fáciles para completar el disfraz',
    description:
      'Ideas para sumar detalles al personaje, con acompañamiento adulto y productos aptos para la piel.',
    pages: '12 páginas',
    cover: 'https://cdn.magicpatterns.com/uploads/gvyyrmdmVJRheY3mXdCzoS/Maquillajes_faciles_de_Halloween-5.png',
  },
  {
    number: '05',
    title: 'Invitaciones y detalles para tu fiesta',
    description: 'Propuestas para anunciar la celebración y personalizar sus detalles.',
    pages: '12 páginas',
    cover: 'https://cdn.magicpatterns.com/uploads/uDdRsiDQ58diG7wzwfEZ8G/Invitaciones_y_detalles_de_Halloween-7.png',
  },
];

export const twoOptionsBenefits = [
  '👻 Personajes clásicos de Halloween',
  '🎨 Opciones simpáticas y coloridas',
  '✂️ Espacio para personalizar',
  '❤️ Una actividad para compartir',
];

export const twoOptionsSteps = ['ELEGÍ', 'REUNÍ LOS MATERIALES', 'CREÁ', 'DISFRUTÁ'];

export const offerChecklist = [
  'Disfraces Tenebrosos — 40 páginas.',
  'Disfraces Divertidos — 40 páginas.',
  'Cinco bonus — 60 páginas en total.',
  'Siete archivos PDF.',
  'Consulta digital o impresión de las páginas que necesites.',
];
